import React from 'react';
export const HighlightSection = () => {
  return <section className="relative bg-gradient-to-b from-[#121212] to-[#0a0a0a] py-24" data-id="element-306" data-mp="nikwonuovrfb">
      {/* Content */}
      <div className="relative z-10 max-w-screen-xl mx-auto px-6 sm:px-8 lg:px-12" data-id="element-307" data-mp="2f2lhwviprd8b">
        <div className="max-w-3xl mx-auto text-center" data-id="element-308" data-mp="214n883fc84z5">
          <h2 className="text-4xl md:text-5xl font-bold text-white uppercase mb-6" data-id="element-309" data-mp="26388u3yi4qo4">
            The BK Signature <span className="text-[#D6281F]" data-id="element-310" data-mp="1rev8yvwamnoc">Experience</span>
          </h2>
          <p className="text-[#CCCCCC] text-lg mb-10 leading-relaxed" data-id="element-311" data-mp="1w5k0ucbvxmo0">
            Bij BKCustoms draait alles om jouw unieke wensen. We luisteren naar
            jouw visie en transformeren je auto met persoonlijke aandacht en
            precisie. Onze signature aanpak combineert vakmanschap met jouw
            persoonlijke stijl voor een resultaat dat écht bij jou past.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16" data-id="element-312" data-mp="1dfce34sht8tz">
            <div className="text-center" data-id="element-313" data-mp="1dekfrm7igx00">
              <div className="text-4xl font-bold text-[#D6281F] mb-2" data-id="element-314" data-mp="6bt7olsmxril">
                Passie
              </div>
              <div className="text-white uppercase tracking-wider text-sm" data-id="element-315" data-mp="1e12iq2zc8wg">
                Voor elk detail
              </div>
            </div>
            <div className="text-center" data-id="element-316" data-mp="fawr5qvps8xm">
              <div className="text-4xl font-bold text-[#D6281F] mb-2" data-id="element-317" data-mp="adehtzdsbrp3">
                Precisie
              </div>
              <div className="text-white uppercase tracking-wider text-sm" data-id="element-318" data-mp="3iurem4trve7x">
                In elke afwerking
              </div>
            </div>
            <div className="text-center" data-id="element-319" data-mp="3eqb8q3k5s6sp">
              <div className="text-4xl font-bold text-[#D6281F] mb-2" data-id="element-320" data-mp="3sjsqpjx75bgm">
                Persoonlijk
              </div>
              <div className="text-white uppercase tracking-wider text-sm" data-id="element-321" data-mp="3ns10xblv79rj">
                Van begin tot eind
              </div>
            </div>
          </div>
          <div className="mt-16" data-id="element-322" data-mp="2v4f02b40uj8d">
            <a href="#portfolio" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-8 py-4 uppercase tracking-wider font-medium transition-colors duration-300 inline-block" data-id="element-323" data-mp="2v3dmnzzj9knh">
              Bekijk Ons Portfolio
            </a>
          </div>
        </div>
      </div>
    </section>;
};